<template>
  <div class="PasswordComponent">

    <b-form class="password-form"  autocomplete="off">



      <b-form-group
        id="input-group-OldPassword"
        :label="lang.label_OldPassword"
        label-for="input-2"
        >

        <b-form-input
          autocomplete="off"
          type="password"
          id="input-OldPassword"
          v-model="form.OldPassword"
          :placeholder="lang.placeholder_OldPassword"
          size="sm"
          required
          aria-describedby="input-OldPassword-feedback"
          :state="validation_OldPassword"

        ></b-form-input>

        <b-form-invalid-feedback id="input-OldPassword-feedback" :state="validation_OldPassword">
          {{lang.validinfo_OldPassword}}
        </b-form-invalid-feedback>
      </b-form-group>

      <b-form-group id="input-group-NewPassword1" :label="lang.label_NewPassword1" label-for="input-2">
        <b-form-input
          autocomplete="off"
          type="password"
          id="input-NewPassword1"
          v-model="form.NewPassword1"
          :placeholder="lang.placeholder_NewPassword1"
          size="sm"
          required
          aria-describedby="input-NewPassword1-feedback"
          :state="validation_NewPassword1"
        ></b-form-input>

        <b-form-invalid-feedback id="input-NewPassword1-feedback" :state="validation_NewPassword1">
          {{lang.validinfo_NewPassword1}}
        </b-form-invalid-feedback>
      </b-form-group>

      <b-form-group id="input-group-NewPassword2" :label="lang.label_NewPassword2" label-for="input-2">
        <b-form-input
          autocomplete="off"
          type="password"
          id="input-NewPassword2"
          v-model="form.NewPassword2"
          :placeholder="lang.placeholder_NewPassword2"
          size="sm"
          required
          aria-describedby="input-NewPassword2-feedback"
          :state="validation_NewPassword2"
        ></b-form-input>

        <b-form-invalid-feedback id="input-NewPassword2-feedback" :state="validation_NewPassword2">
          {{lang.validinfo_NewPassword2}}
        </b-form-invalid-feedback>



      </b-form-group>

      <b-button @click="confirmUpdatepassword" class="password-form-button" size="sm" :variant="variant">{{lang.button_Confirm}}</b-button><br><br>


    </b-form>
  </div>
</template>

<script>
//import CreatePropertyComponent from '@/components/shared/CreatePropertyComponent'


export default {
  name: "PasswordComponent",
  components: {



  },
  props:{
    lang: Object
  },
  data () {
    return {
      form: {


        OldPassword: '',
        NewPassword1: '',
        NewPassword2: '',

      },

      inputStatus: null,


    }
  },
  computed: {

    validation_OldPassword() {
      if (this.form.OldPassword.length == 0){
        return null;
      }
      return this.form.OldPassword.length > 3
    },
    validation_NewPassword1() {
      if (this.form.NewPassword1.length == 0){
        return null;
      }
      return this.form.NewPassword1.length >= 6
    },
    validation_NewPassword2() {
      if (this.form.NewPassword2.length == 0){
        return null;
      }
      return this.form.NewPassword1 ==  this.form.NewPassword2
    },
    variant(){
      if (this.$store.getters.s_skinVariant == "dark"){
        return "light";
      }else{
        return "dark";
      }
      
    }

  },
  created() {




  },
  updated(){



  },
  methods: {
    confirmUpdatepassword(){
      
      if ((this.form.NewPassword1.trim() == this.form.NewPassword2.trim()) && (this.form.NewPassword1.trim() != "")){

        let _vue = this;
        let obj = {
          login: this.$store.getters.currentUser.login.trim(),
          oldPassword: this.form.OldPassword.trim(),
          newPassword: this.form.NewPassword1.trim()
        }

        let payload = _vue.$store.dispatch(_vue.$store.getters.sectionPrefix + "_updatePassword", obj)
        .then(function(result) {
          
          console.log(result)

          if (result.data == 1){


            let obj = {
              text: _vue.lang.alert_Success,
              time: 5,
              type: "success"
            }

            _vue.$store.dispatch("displayFooterAlert", obj)

          }else{


            let obj = {
              text: _vue.lang.alert_Error,
              time: 5,
              type: "danger"
            }

            _vue.$store.dispatch("displayFooterAlert", obj)
          }


        })
      }else{


      }

    }
  }
}
</script>
<style lang="scss">
  .PasswordComponent{
    .password-form{
      max-width: 300px;
    }
    .password-form-button{
      float: right;
    }
  }



</style>



// WEBPACK FOOTER //
// src/components/shared/PasswordComponent.vue